import { createSelector } from 'reselect';
import {
    ApartmentAssets,
    DetailedIssueReport,
    DoorStatus,
    IssueReport,
    Thing,
} from '../api/types';
import { RootState } from '../store/store';
import { IssueReportsFetchStatus } from '../reducer/issueReportsReducer';
import { makePermissionListSelector } from './authenticationSelector';

const stateKey = 'issueReports';

export const detailedIssueReportSelector = (
    state: RootState,
): DetailedIssueReport | null => state.legacy[stateKey].issueReport;

export const assetListSelector = (state: RootState): ApartmentAssets[] => state.legacy[stateKey].assets;

export const issueReportListSelector = (state: RootState): IssueReport[] =>
    state.legacy[stateKey].issueReports;
export const issueReportsFetchStatusSelector = (state: RootState): IssueReportsFetchStatus =>
    state.legacy[stateKey].issueReportsFetchStatus;
export const issueReportCreatedSelector = (state: RootState): Boolean =>
    state.legacy[stateKey].issueReportCreated;
export const issueReportCreateFailedSelector = (state: RootState): boolean =>
    state.legacy[stateKey].issueReportCreateFailed;
export const createdIssueReportIdSelector = (state: RootState): string | null =>
    state.legacy[stateKey].createdIssueReportId;

export const doorStatusListSelector = (
    state: RootState,
): Record<string, DoorStatus> => state.legacy[stateKey].doorStatus;
export const thingListSelector = (state: RootState): Thing[] =>
    state.legacy[stateKey].things;


export const makeIssueReportSelector = (issueReportId: string) => {
    return createSelector(
        [issueReportListSelector],
        (issueReportsList): IssueReport | undefined => {
            return issueReportsList.find(
                (damageReport) => damageReport.id === issueReportId,
            );
        },
    );
};

export const makeDetailedIssueReportSelector = () => {
    return createSelector(
        [detailedIssueReportSelector],
        (detailedIssueReport): DetailedIssueReport | null => {
            return detailedIssueReport;
        },
    );
};

export const makePermittedIssueReportListSelector = () => {
    return createSelector(
        [issueReportListSelector, makePermissionListSelector()],
        (issueReportsList): IssueReport[] => {
            return issueReportsList;
            // if (permissionsList.includes(Permission.accessDamageReportsBookingStats())) {
            //     return issueReportsList;
            // }

            // return issueReportsList.filter(
            //     damageReport => permissionsList.includes(Permission.accessDamageReportBookingStats(damageReport.id)),
            // );
        },
    );
};
